import { ProductVariant } from './catalog.model';

export type CartItemProduct = {
  _id: string;
  name: string;
  slug: string;
};

export type Item = {
  product: CartItemProduct;
  quantity: number;
  variant: ProductVariant;
};

export type Cart = {
  items: Item[];
  isLoading: boolean;
  cartId: string | null;
  someItemOutOfStock: boolean;
  syncedBaseline: Record<string, number>;
};

export enum CartItemAction {
  REMOVE_ITEM = 'REMOVE_ITEM',
  ADD_ITEM = 'ADD_ITEM',
}
